/* eslint-disable import/no-anonymous-default-export */
import GlobalConsts from '../../Utils/Constants/GlobalConsts';
import AuthConstants from './AuthConsts'

const initialState = {
    data: '',
    message: '',
    status: false,
    token: '',
    isAuthenticated: false,
    // If there's no token in storage, there's nothing to verify — skip the wait.
    sessionChecked: !localStorage.getItem('token'),
    theme: localStorage.theme || GlobalConsts.LIGHT,
    currentRoute: window.location.pathname || '/landing',
    user: {},
}

export default (state = initialState, action) => {
    switch (action.type) {
        case AuthConstants.CHANGE_THEME: {
            return {
                ...state,
                theme: action.payload.theme,
            };
        }
        case AuthConstants.LOGIN_SUCCESS: {
            return {
                ...state,
                isAuthenticated: true,
                token: action.payload.data.token,
                user: action.payload.data.user,
            };
        }
        case AuthConstants.USER_LOGIN_SUCCESS: {
            return {
                ...state,
                isAuthenticated: true,
                token: action.payload.data.token,
                user: action.payload.data.user,
            };
        }
        case AuthConstants.CHECK_LOGIN_SUCCESS: {
            return {
                ...state,
                isAuthenticated: true,
                sessionChecked: true,
                user: action.payload.data.user,
            };
        }
        case AuthConstants.SESSION_CHECKED: {
            return {
                ...state,
                sessionChecked: true,
            };
        }
        case AuthConstants.LOGOUT: {
            return {
                ...state,
                isAuthenticated: false,
                sessionChecked: true,
            };
        }
        case AuthConstants.REDIRECT_SCREEN: {
            return {
                ...state,
                currentRoute: action.payload.currentRoute || window.location.pathname
            };
        }
        default:
            return state
    }
}
